<template>
  <div id="pinger-index">
    <div id="page-head">
      <ul id="breadcrumbs">
        <li>
          <router-link :to="{ name: 'Dashboard' }">Dashboard</router-link>
        </li>
        <li>Site Pinger</li>
      </ul>
    </div>

    <div class="panel">
      <div class="panel-head">
        <h2>Domains</h2>
        <ul class="actions">
          <li>
            <router-link :to="{ name: 'PingerCreate' }" class="action">New Domain</router-link>
          </li>
        </ul>
      </div>

      <div class="panel-content">
        <table>
          <thead>
            <th>Client</th>
            <th>Status</th>
            <th>Root Domain</th>
            <th>Interval</th>
            <th>Last Checked</th>
            <th>Last Down</th>
          </thead>
          <tbody>
            <template v-for="client in clients">
              <tr v-for="domain in client.pingers" :key="domain.id" :class="{ 'disabled': (domain.interval == -1) }">
                <td class="client-name">{{client.name}}</td>
                <td class="status">
                  <i v-if="domain.is_down" class="fa fa-times"></i>
                  <i v-else class="fa fa-check"></i>
                </td>
                <td>
                  <router-link
                    :to="{ name: 'PingerEdit', params: { id: domain.id }}"
                  >{{ domain.domain }}</router-link>
                </td>
                <td>
                  <template v-if="domain.interval == -1">Disabled</template>
                  <template v-else-if="domain.interval > 0">{{ domain.interval }} hr</template>
                </td>
                <td>{{ domain.last_checked_at == null ? '--' : formatDate(domain.last_checked_at) }}</td>
                <td>{{ domain.last_down_at == null ? '--' : formatDate(domain.last_down_at)}}</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import "moment-timezone";

export default {
  name: "PingerIndex",
  data() {
    return {
      clients: []
    };
  },
  created() {
    this.loadPingers();
  },
  methods: {
    async loadPingers() {
      let response = await this.$http.get("/pingers");
      this.clients = response.data;
    },
    formatDate(date) {
      return moment(date)
        .tz("America/New_York")
        .format("YYYY-MM-DD @ hh:mmA");
    }
  }
};
</script>

<style lang="scss">
#pinger-index {
  tr.disabled td {
    color: $medium-gray;
    a { color: inherit; }
    .fa-check { color: inherit; opacity: 0.5; }
  }
  .fa-check {
    color: $green;
  }
  .fa-times {
    color: $red;
  }
  .client-name {
    font-weight: 700;
  }
  .status {
    text-align: center;
  }
}
</style>
